/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "BreadcrumbService";
const log: any = LoggerModule.getInstance();

export class BreadcrumbService {
  private static instance: BreadcrumbService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): BreadcrumbService {
    if (!BreadcrumbService.instance) {
      BreadcrumbService.instance = new BreadcrumbService(props);
    }
    return BreadcrumbService.instance;
  }

  public getBreadCrumbItems() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getBreadcrumbItemsSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
